<template>
  <v-expansion-panel readonly class="expansion-panel">
    <v-expansion-panel-header class="expansion-panel-header">
      <div class="expansion-panel-header-content">
        <v-col>
          <ThemedCheckbox
            :label="panelLabel"
            @click="onCheckboxClicked()"
            expand-icon="mdi-plus"
            v-model="modelValue"
            :input-value="modelValue"
          ></ThemedCheckbox>
        </v-col>
        <v-col class="mt-4">
          <slot name="headerContent"></slot>
        </v-col>
      </div>
      <template v-slot:actions>
        <v-icon color="transparent"> mdi-check </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content color="var(--color-surface)">
      <slot name="panelContent"></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";
export default {
  name: "CheckboxExpansionPanel",
  components: { ThemedCheckbox },
  props: {
    onCheckboxClicked: Function,
    panelLabel: String,
    model: Boolean,
  },
  computed: {
    modelValue: {
      get() {
        return this.model;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped>
.expansion-panel {
  background-color: var(--color-surface);
}
.expansion-panel-header {
  background-color: var(--color-surface);
}
.expansion-panel-header-content {
  display: flex;
  align-items: center;
}
</style>


